










import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import { RailwayModule } from '@/store/modules/railway'

@Component({
  name: "design-train",
  components: {
  }
})
export default class DesignTrain extends Vue {
  get title() {
    return RailwayModule.title
  }
}
